import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fromEvent } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import * as Root from '../actions/root.actions';
import {
  getStoredUserType,
  handleContractorLogout,
  isContractorSession,
} from '@libraries/helpers';

@Injectable()
export class RootEffects {
  constructor(private actions$: Actions) {}

  requestAuthToken$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(Root.RequestAuthToken),
        tap(() => {
          if (window !== window.parent) {
            window.parent.postMessage({ type: 'REQUEST_AUTH_TOKEN', loaded: true }, '*');
            window.parent.postMessage({ loaded: true }, '*');
          } else if (window.opener && !window.opener.closed) {
            window.opener.postMessage({ type: 'REQUEST_AUTH_TOKEN', loaded: true }, '*');
          }
        })
      ),
    { dispatch: false }
  );

  handleAuthToken$ = createEffect(() =>
    fromEvent<MessageEvent>(window, 'message').pipe(
      map((event) => {
        if (!event.data) return null;
        if (event.data.type === 'LOGOUT' || event.data.type === 'SESSION_EXPIRED') {
          const isContractor =
            isContractorSession() ||
            getStoredUserType() === 'contractor' ||
            (typeof sessionStorage !== 'undefined' &&
              (sessionStorage.getItem('apply_user_type') === 'contractor' ||
                sessionStorage.getItem('is_contractor_session') === 'true'));
          if (isContractor) {
            handleContractorLogout('logged_out_in_other_tab');
          }
          return Root.ClearAuthToken();
        }
        const authToken =
          event.data.authToken ||
          event.data.auth_token ||
          event.data.token ||
          (typeof event.data === 'string' && event.data.startsWith('eyJ') ? event.data : null);
        const userType = event.data.userType;
        return authToken ? Root.SetAuthToken({ authToken, userType }) : null;
      }),
      filter((action): action is NonNullable<typeof action> => !!action)
    )
  );

  handleStorageLogout$ = createEffect(() =>
    fromEvent<StorageEvent>(window, 'storage').pipe(
      filter((event) => {
        const isContractorLogoutKey =
          event.key === 'contractor_logged_out' || event.key === 'contractor_logged_out_at';
        if (isContractorLogoutKey) {
          const isContractor =
            isContractorSession() ||
            getStoredUserType() === 'contractor' ||
            (typeof sessionStorage !== 'undefined' &&
              (sessionStorage.getItem('apply_user_type') === 'contractor' ||
                sessionStorage.getItem('is_contractor_session') === 'true'));
          return isContractor;
        }
        return (
          (event.key === 'contractor_auth_token' || event.key === 'apply_auth_token') &&
          !event.newValue
        );
      }),
      tap(() => {
        const isContractor =
          isContractorSession() ||
          getStoredUserType() === 'contractor' ||
          (typeof sessionStorage !== 'undefined' &&
            (sessionStorage.getItem('apply_user_type') === 'contractor' ||
              sessionStorage.getItem('is_contractor_session') === 'true'));
        if (isContractor) {
          handleContractorLogout('logged_out_in_other_tab');
        }
      }),
      map(() => Root.ClearAuthToken())
    )
  );
}
